import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RtcListener {
    username: string | null;
    newCall: boolean | null;
    callinprocess?: boolean
}

export const voiceAlertSlice = createSlice({
    name: 'voiceAlert',
    initialState: {
        voiceAlert: {
            username: null,
            newCall: null
        }
    } as { voiceAlert: RtcListener },
    reducers: {
        setVoiceAlert: (state, action: PayloadAction<RtcListener>) => {
            state.voiceAlert.username = action.payload.username;
            state.voiceAlert.newCall = action.payload.newCall;
        },
        setCallInProcess: (state, action: PayloadAction<{callinprocess: boolean}>) => {
            state.voiceAlert.callinprocess = action.payload.callinprocess;
        }
    },
});

export const { setVoiceAlert, setCallInProcess } = voiceAlertSlice.actions;
export default voiceAlertSlice.reducer;